module.exports = __webpack_public_path__ + "img/plantilla_hotel.d5a8bc3a.png";